{
  "signInRecovery": {
    "title": "Connexion interrompue",
    "processing": "Finalisation de la connexion…",
    "message": "La connexion n’a pas pu être finalisée. Reconnectez-vous pour continuer.",
    "action": "Se reconnecter",
    "starting": "Connexion en cours…",
    "restartFailed": "La connexion n’a pas pu démarrer. Vérifiez que votre navigateur autorise le stockage des données du site, puis réessayez."
  },
  "loading": "Chargement...",
  "save": "Enregistrer",
  "cancel": "Annuler",
  "delete": "Supprimer",
  "search": "Rechercher",
  "close": "Fermer",
  "confirm": "Confirmer",
  "yes": "Oui",
  "no": "Non",
  "error": "Erreur",
  "success": "Succ\u00e8s",
  "retry": "R\u00e9essayer",
  "upload": "T\u00e9l\u00e9verser",
  "download": "T\u00e9l\u00e9charger",
  "logout": "D\u00e9connexion",
  "back": "Retour",
  "redirectingToLogin": "Redirection vers la connexion...",
  "profile": "Profil",
  "settings": "Param\u00e8tres",
  "user": "Utilisateur",
  "unnamedPerson": "Nom non enregistr\u00e9",
  "language": "Langue",
  "selectLanguage": "S\u00e9lectionner votre langue",
  "appSwitcher": {
    "selectApp": "S\u00e9lectionner l\u2019application",
    "title": "Applications",
    "description": "Basculer entre les applications Agion",
    "tooltip": "Changer d\u2019application",
    "admin": "Admin",
    "control": "Contr\u00f4le",
    "app": "App",
    "analytics": "Analytique"
  },
  "adminDashboard": "Tableau de bord admin",
  "profileSettings": "Profil et param\u00e8tres",
  "uploadFiles": "T\u00e9l\u00e9verser des fichiers",
  "uploadingFiles": "T\u00e9l\u00e9versement des fichiers...",
  "pleaseWait": "Veuillez patienter",
  "dropFilesHere": "D\u00e9posez les fichiers ici",
  "dropFilesOrClick": "D\u00e9posez les fichiers ou cliquez",
  "fileTypes": "Excel, CSV, JSON jusqu\u2019\u00e0 {{size}} Mo",
  "status": {
    "active": "Actif",
    "busy": "Occup\u00e9",
    "offline": "Hors ligne",
    "pending": "En attente",
    "uploading": "T\u00e9l\u00e9versement",
    "processing": "Traitement",
    "completed": "Termin\u00e9",
    "error": "Erreur",
    "uploaded": "Charg\u00e9",
    "processed": "Trait\u00e9"
  },
  "roles": {
    "owner": "Propri\u00e9taire",
    "admin": "Administrateur",
    "manager": "Responsable",
    "user": "Utilisateur",
    "auditor": "Auditeur"
  },
  "you": "Vous",
  "agent": "Agent",
  "manager": "Responsable",
  "agents": {
    "system": {
      "assistant": "Agion Assistant"
    }
  },
  "hitl": {
    "expired": "Cette demande a expir\u00e9.",
    "timeout": "Expire dans {{time}}",
    "placeholder": "Tapez votre r\u00e9ponse...",
    "governanceRule": "R\u00e8gle de gouvernance : {{rule}}",
    "operatorHandoff": {
      "title": "L\u2019agent a besoin de l\u2019aide d\u2019un op\u00e9rateur",
      "description": "L\u2019agent ne peut pas r\u00e9soudre ceci et demande une assistance humaine"
    },
    "policyReview": {
      "title": "Examen de gouvernance requis",
      "description": "Une politique de gouvernance n\u00e9cessite un examen humain avant de poursuivre",
      "approve": "Approuver",
      "deny": "Refuser",
      "decideElsewhere": "Cette approbation se d\u00e9cide dans Escalades.",
      "openEscalations": "D\u00e9cider dans Escalades"
    }
  },
  "nextShell": {
    "sidebar": "Navigation du chat",
    "missionsNavigation": "Missions",
    "missionsLoadError": "Les missions n'ont pas pu être chargées",
    "expandSidebar": "Déplier la barre latérale",
    "collapseSidebar": "Replier la barre latérale",
    "openNavigation": "Ouvrir la navigation",
    "closeNavigation": "Fermer la navigation",
    "organization": "Organisation",
    "files": "Fichiers",
    "running": "En cours",
    "theme": {
      "currentLight": "Mode clair",
      "currentDark": "Mode sombre",
      "switchToLight": "Passer au mode clair",
      "switchToDark": "Passer au mode sombre"
    },
    "appSwitcher": {
      "chat": "Chat",
      "switchApp": "Changer d'application",
      "currentApp": "Application actuelle",
      "open": "Ouvrir"
    }
  },
  "nextFailure": {
    "hostUnknown": "L'hôte Edge qui a exécuté cette mission n'est pas enregistré, sa conversation est donc introuvable.",
    "hostOfflineNamed": "{{name}}, l'hôte Edge qui contient cette conversation, est hors ligne. Réessayez lorsqu'il sera de retour.",
    "hostOffline": "L'hôte Edge qui contient cette conversation est hors ligne. Réessayez lorsqu'il sera de retour.",
    "network": "La connexion à Agion a échoué. Vérifiez votre réseau et réessayez.",
    "unavailable": "Le service ne répond pas pour le moment. Réessayez dans un instant.",
    "session": "Votre session a expiré. Reconnectez-vous pour continuer.",
    "forbidden": "Votre rôle ne le permet pas.",
    "missing": "L'élément n'existe plus ou a été déplacé.",
    "refused": "La demande a été refusée.",
    "unknown": "Une erreur s'est produite. Réessayez."
  }
}
